export enum TypeOfSourceRequest {
  GENERAL_ENQUIRY_VIA_COMPANY = 1,
  PRODUCT_INQUIRY_VIA_COMPANY = 2,
  NAMECARD_VIA_COMPANY = 3,
  GENERAL_ENQUIRY_VIA_PRODUCT = 11,
  RFQ_INQUIRY_VIA_PRODUCT = 12,
}

//1: General enquiry via Company (this is via 'messages/company/text with type:1)
//2: Product inquiry via company (this is via 'messages/company/text with type:2)
//3: Namecard via company (this is via 'messages/company/vcard)
//11: General enquiry via Product (this is via 'messages/company/text with type:11)
//12: RFQ inquiry via Product (this is via 'messages/company/text with type:12)
